import { MotifButton, MotifModalBody, MotifModalFooter } from '@ey-xd/motif-react'
import React from 'react'
import ViewQuestionsUtilityBar from './ViewQuestionsUtilityBar'
import ViewQuestionsTable from './ViewQuestionsTable'
import { useDispatch, useSelector } from 'react-redux';

const ViewQuestions = (props) => {
    const { content, closeHandler } = props  
    const { access } = useSelector((state: any) => state.user);
    const dispatch = useDispatch();
    const onCancel = () => {
        closeHandler()
    }
    const onSave = () => {
        dispatch({ type: "CONVERSATION_MESSAGE_SEND", payload: { text: "proceed-questionnaire" } });
        closeHandler()
    }
    
    return (
        <>
            <MotifModalBody className='min-h-20 !pt-4 !mb-5 !overflow-hidden bg-[#1A1A24] view-question-utility-bar-container'>
                <ViewQuestionsUtilityBar {...props} />
            </MotifModalBody>
            <MotifModalBody className='min-h-80 !pt-0'>
                <ViewQuestionsTable {...props} />
            </MotifModalBody>
            <MotifModalFooter style={{borderTop: "1px solid #A4A3B1"}} className="!py-0 !pb-0">

                <div className="flex justify-end gap-2 my-4">
                    {access?.write === true && (
                        <MotifButton
                            className="!mt-0"
                            onClick={onSave}
                            type="button"
                        >
                            Proceed
                        </MotifButton>
                    )}
                </div>
            </MotifModalFooter>
        </>
    )
}

export default ViewQuestions